export const errors = {
  not_found: {
    title: 'Not found!',
    description: 'This page could not be found',
    action: 'Back to home',
  },
}
